export default "__VITE_ASSET__JQa6ZOVf__"